import { NestedRoutes } from "../../../app/routes.types";
import { PersonalInfo } from "./PersonalInfo/personalInfo";
import { EmployeeInfo } from "./EmployeeInfo/employeeInfo";
import { StrengthsFinder } from "./StrengthsFinder/strengthsFinder";
import { CheckInRoutes } from "./CheckIns/checkIns.routes";
import { Members } from ".";
import MembersIcon from "../../../assets/Admin/Members";
import { MemberLayout } from "./layout";
import { Api } from "../../../services/api";
import { makeName } from "../../../services/hooks/MembersList";
import { UserPermissions } from "../../../enums";

export const MemberEditLayout: NestedRoutes = {
  name: "Edit",
  getName: async (params: Record<string, string>) => {
    return await Api.members.getMemberDetails(params.memberId).then(res => {
      return makeName(res.data.member);
    });
  },
  path: ":memberId",
  layout: MemberLayout,
  defaultPath: "personalInformation",
  children: [
    {
      name: "Personal Information",
      path: "personalInformation",
      component: PersonalInfo,
      permissions: [
        UserPermissions.MemberViewPersonal,
        UserPermissions.MemberManagePersonal,
      ],
    },
    {
      name: "Team Member Information",
      path: "teamMemberInformation",
      component: EmployeeInfo,
      permissions: [
        UserPermissions.MemberViewEmployment,
        UserPermissions.MemberManageEmployment,
      ],
    },
    CheckInRoutes,
    {
      name: "StrengthsFinder",
      path: "StrengthsFinder",
      component: StrengthsFinder,
      permissions: [
        UserPermissions.MemberViewStrengthFinder,
        UserPermissions.MemberManageStrengthFinder,
      ],
    },
  ],
};

export const MemberRoutes: NestedRoutes = {
  icon: MembersIcon,
  name: "Members",
  path: "members",
  component: Members,
  children: [MemberEditLayout],
  permissions: [UserPermissions.MemberViewList],
};
